import { useTranslation } from 'react-i18next'
import { Award, ShieldCheck } from 'lucide-react'
import LogoGrid from './LogoGrid'
import { ACCREDITATION_LOGOS } from '../../data/siteContent'

export default function AccreditationsPageContent() {
  const { t } = useTranslation()

  return (
    <div className="space-y-12">
      <div>
        <p className="mb-2 text-sm font-bold uppercase tracking-widest text-accent">
          {t('accreditationsPage.introLabel')}
        </p>
        <p className="text-lg leading-relaxed text-text/75">{t('accreditationsPage.intro1')}</p>
        <p className="mt-4 text-lg leading-relaxed text-text/75">{t('accreditationsPage.intro2')}</p>
      </div>

      <div className="rounded-2xl border border-border border-s-primary bg-white p-6 shadow-sm shadow-primary/5 sm:p-8">
        <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl gradient-brand">
          <ShieldCheck className="h-7 w-7 text-white" />
        </div>
        <h2 className="mb-3 text-2xl font-bold text-primary">{t('accreditationsPage.sectionTitle')}</h2>
        <p className="leading-relaxed text-text/70">{t('accreditationsPage.sectionText1')}</p>
        <p className="mt-4 leading-relaxed text-text/70">{t('accreditationsPage.sectionText2')}</p>
      </div>

      <div>
        <div className="mb-6 flex items-center justify-center gap-2 text-center">
          <Award className="h-5 w-5 text-accent" />
          <h2 className="text-xl font-bold text-primary">{t('accreditationsPage.logosTitle')}</h2>
        </div>
        <LogoGrid logos={ACCREDITATION_LOGOS} />
      </div>
    </div>
  )
}
